/// <reference path="../../typings/nvd3/nvd3.d.ts" />
/// <reference path="../../typings/d3/d3.d.ts" />
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";

@Component({
	selector: "chart",
	template: `<div id="chart"><svg style="height:300px;"></svg></div>`
})

export class ChartComponent implements OnChanges, OnDestroy {
	@Input() chartData: any;

	ngOnChanges(changes: SimpleChanges) {
		if (changes["chartData"] && changes["chartData"].currentValue !== changes["chartData"].previousValue) {
			let self = this;
			nv.addGraph(function () {
				let chart = nv.models.lineChart()
					.useInteractiveGuideline(true)
					.x(function (d) { return d[0]; })
					.y(function (d) { return d[1]; })
					.duration(300);

				chart.margin({ top: 0, right: 0, bottom: 40, left: 40 });

				chart.xAxis
					.tickFormat(function (d) {
						return d3.time.format("%d/%m/%y")(new Date(d));
					})
					.showMaxMin(false);

				chart.yAxis
					.tickFormat(d3.format(".0d"));

				d3.select("#chart svg")
					.datum(self.chartData)
					.call(chart);

				nv.utils.windowResize(chart.update);
				return chart;
			});
		}
	}

	ngOnDestroy() {
		d3.select(".nvtooltip").remove();
		d3.select("#chart svg").remove();
	}
}
